import React from 'react';
import useStyle from './myAccountBlock.style';
import { BadgeAvatar } from '../../Badges/BadgeAvatar';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import { classNames } from '../../../../helpers/style/classNames';
import { getShopUrl, getValidShop } from '../../../../domain/shop';
import { HeaderText } from '../../../atoms/Texts/HeaderText';
import emojis from '../../../../theme/emoji';
import { MY_ID } from '../../../../helpers/user/authorization';
import { ID } from 'types/typeDef';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { Modal } from '../../../organisms/Modals/Modal';
import { BackButton } from 'components/molecules/Buttons/BackButton';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { QueryUserAccountQuery } from '../../../../graphql/generated/graphql';
import { IS_PROF } from '../../../../helpers/user/authorization';

interface MyAccountBlockProps {
  user: QueryUserAccountQuery['getUserAccount'];
  deleteLoading?: boolean;
  deleteUser?: (id: ID) => Promise<void>;
}

export const MyAccountBlock = ({
  user,
  deleteLoading = false,
  deleteUser
}: MyAccountBlockProps) => {
  const classes = useStyle();
  const validShop = getValidShop(user?.note?.nbvente, IS_PROF);

  return (
    <>
      {user.id !== MY_ID && <BackButton text="Retourner sur Ma Classe" />}
      <ContainerFullWidth>
        <HeaderText
          text={user.id === MY_ID ? 'Mes informations' : 'Compte élève'}
          emoji={emojis['CardIndex']}
        />
        <FeatureContainer
          buttonWithText={
            user.id !== MY_ID && (
              <Modal
                modalHead="Êtes-vous sûr de vouloir supprimer cet élève ?"
                triggerButton={
                  <ButtonWithText
                    onClick={null}
                    variant="danger"
                    content="Supprimer l'élève de la classe"
                    disabled={deleteLoading}
                  />
                }
                actionButton={
                  <ButtonWithText
                    content="Oui je suis sûr !"
                    onClick={() => deleteUser(user.id)}
                  />
                }
              >
                <p>
                  Vous êtes sur le point de supprimer {user.firstname} de votre
                  classe. Il sera définitivement supprimé. Êtes-vous sûr de
                  vouloir valider cette action ?
                </p>
              </Modal>
            )
          }
        >
          <BadgeAvatar user={user} variant={'profile'} />
          <div className={classes.line}>
            <FlatIcon icon={'Mail'} />
            <p className={classes.text}>{user.email}</p>
          </div>
          <div className={classes.line}>
            <FlatIcon icon={'Phone'} />
            <p className={classes.text}>{user.tel}</p>
          </div>
          <div className={classes.line}>
            <FlatIcon icon={'Briefcase'} />
            <p className={classes.text}>
              {user.classe?.niveau?.name +
                ' ' +
                user.classe?.filiere?.name +
                ' : Lycée ' +
                user.classe?.lycee?.name}
            </p>
          </div>
          <div className={classes.line}>
            <FlatIcon icon={'Link'} />
            <p
              className={classNames(
                [classes.text],
                [{ condition: !validShop, classe: classes.blurText }]
              )}
            >
              {getShopUrl(user?.shop, user.classe.id)}
            </p>
          </div>
        </FeatureContainer>
      </ContainerFullWidth>
    </>
  );
};
